import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputTextSF from '../../widgets/form/InputTextSF'

const PinCodeUpdateUI = ({ context, messageList, successMsg, errorList,
  submitted, onSubmit, onCancel, setErrorList,
  oldPinCode, oldPinCodeError, onOldPinCodeChange, setOldPinCodeError,
  newPinCode, newPinCodeError, onNewPinCodeChange, setNewPinCodeError,
  reenterPinCode, reenterPinCodeError, onReenterPinCodeChange, setReenterPinCodeError
}) =>
  <CardUI context={context}>
    <FormSF context={context}
      messageList={messageList} buttonMessageKey='c_update' cancelMessageKey='c_cancel'
      successMsg={successMsg} errorList={errorList}
      busy={submitted} onSubmit={onSubmit} onCancel={onCancel} setErrorList={setErrorList}
    >
      <InputTextSF type='password' name='oldPinCode' required={true} maxLength={4}
        messageList={messageList} labelKey='c_old_pincode'
        value={oldPinCode} error={oldPinCodeError} onChange={onOldPinCodeChange} setError={setOldPinCodeError}
        autoFocus={true}
      />
      <InputTextSF type='password' name='newPinCode' required={true} maxLength={4}
        messageList={messageList} labelKey='c_new_pincode'
        value={newPinCode} error={newPinCodeError} onChange={onNewPinCodeChange} setError={setNewPinCodeError}
      />
      <InputTextSF type='password' name='reenterPinCode' required={true} maxLength={4}
        messageList={messageList} labelKey='c_reenter_pincode'
        value={reenterPinCode} error={reenterPinCodeError} onChange={onReenterPinCodeChange} setError={setReenterPinCodeError}
      />
    </FormSF>
  </CardUI>

export default PinCodeUpdateUI
